/**
 * Layout constants for ScenarioExplainerClip. Values are in reference pixels
 * for a 1080-wide canvas and are multiplied by getVideoScale(width, height).
 *
 * Safe areas: TikTok / Shorts / Reels overlay UI on roughly the top 12% and
 * bottom 20% of a 9:16 frame, so all text stays inside that band. Feed
 * placements (1:1 on X / LinkedIn) only need small margins.
 */
import { getVideoScale } from "../theme";

export const SOCIAL_LAYOUTS = {
  vertical: {
    safeTopPct: 0.12,
    safeBottomPct: 0.2,
    sidePad: 72,
    gap: 28,
    headerHeight: 84,
    logoSize: 60,
    brandFont: 30,
    chipFont: 28,
    hookFont: 96,
    tickerFont: 150,
    strategyFont: 56,
    legsFont: 38,
    tileLabelFont: 24,
    tileValueFont: 50,
    chartHeight: 860,
    chartHeightCompact: 560,
    chartFont: 26,
    bigNumberFont: 168,
    bigLabelFont: 38,
    captionFont: 60,
    captionBoxHeight: 196,
    footerFont: 21,
    ctaFont: 96,
    urlFont: 56,
    endTitleFont: 46,
    endBodyFont: 32,
    endMetaFont: 28,
  },
  square: {
    safeTopPct: 0.05,
    safeBottomPct: 0.055,
    sidePad: 60,
    gap: 16,
    headerHeight: 60,
    logoSize: 46,
    brandFont: 24,
    chipFont: 22,
    hookFont: 70,
    tickerFont: 96,
    strategyFont: 42,
    legsFont: 28,
    tileLabelFont: 18,
    tileValueFont: 36,
    chartHeight: 540,
    chartHeightCompact: 370,
    chartFont: 20,
    bigNumberFont: 100,
    bigLabelFont: 28,
    captionFont: 42,
    captionBoxHeight: 124,
    footerFont: 16,
    ctaFont: 72,
    urlFont: 42,
    endTitleFont: 36,
    endBodyFont: 25,
    endMetaFont: 22,
  },
};

/** Vertical layout for portrait frames; square constants for 1:1 and landscape. */
export function getSocialLayout(width, height) {
  const key = height > width ? "vertical" : "square";
  const base = SOCIAL_LAYOUTS[key];
  const scale = getVideoScale(width, height);
  const s = (value) => Math.round(value * scale);
  return {
    key,
    s,
    safeTop: Math.round(height * base.safeTopPct),
    safeBottom: Math.round(height * base.safeBottomPct),
    sidePad: s(base.sidePad),
    L: base,
  };
}
